import { render, staticRenderFns } from "./UserInfoDialog.vue?vue&type=template&id=1d0150a0&scoped=true&"
import script from "./UserInfoDialog.vue?vue&type=script&lang=js&"
export * from "./UserInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0150a0",
  null
  
)

export default component.exports